import AntecipacaoRecebiveisInterceptor from '@finx/web-repository/src/apis/AntecipacaoRecebiveis/AntecipacaoRecebiveisInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AntecipacaoRecebiveisInterceptor()

const buildPaginacaoQuery = (params: any) => {
  let query = '&paginar=true'

  if (params.pagina) query += `&pagina=${params.pagina}`
  if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`

  return query
}

const finishQuery = (query: string) => (query.length > 0 ? `?${query.substr(1, query.length - 1)}` : '')

export default {
  async uploadArquivo(formData: any) {
    // Envia via post autenticado (Bearer token). O FormData faz o axios definir
    // automaticamente o Content-Type multipart/form-data com boundary.
    const request = await api.post('importacao/upload', formData)
    return factory.build(request)
  },

  async getImportacoes(params: any) {
    let query = buildPaginacaoQuery(params)
    if (params.status) query += `&status=${params.status}`

    const request = await api.get(`importacao${finishQuery(query)}`)
    return factory.build(request)
  },

  async getImportacaoItens(params: any) {
    let query = buildPaginacaoQuery(params)
    if (params.status) query += `&status=${params.status}`

    const request = await api.get(`importacao/${params.id}/itens${finishQuery(query)}`)
    return factory.build(request)
  },

  async getLiquidacoesRecebiveis(params: any) {
    let query = buildPaginacaoQuery(params)
    if (params.status) query += `&status=${params.status}`
    if (params.identificadorOrigem) query += `&identificadorOrigem=${encodeURIComponent(params.identificadorOrigem)}`

    const request = await api.get(`liquidacoes-recebiveis${finishQuery(query)}`)
    return factory.build(request)
  },
}
